import { ProjectCostCodeCostTypeItemBase } from './base/project-cost-code-cost-type-item-base';

export class ProjectCostCodeCostTypeItem extends ProjectCostCodeCostTypeItemBase { }